var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_02a73942"]},_vm.$listeners),[_c('cube-slider',{attrs:{"value":(30),"custom-content":(true)},on:{"change":(e)=>_vm.__invoke(e, [["handleChange"]]),"changing":(e)=>_vm.__invoke(e, [["handleChanging"]])}},[_c('div',{class:["slider-thumb"]},[_c('div',{class:["box"]})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }